{
  "absoluteDirectionPad": {
    "title": "上 (↑ / W)",
    "ariaLabel": "大移動: 上",
    "title2": "下 (↓ / S)",
    "ariaLabel2": "大移動: 下",
    "title3": "左 (← / A)",
    "ariaLabel3": "大移動: 左",
    "title4": "右 (→ / D)",
    "ariaLabel4": "大移動: 右",
    "title5": "上 (Shift+↑ / Shift+W)",
    "ariaLabel5": "小移動: 上",
    "title6": "下 (Shift+↓ / Shift+S)",
    "ariaLabel6": "小移動: 下",
    "title7": "左 (Shift+← / Shift+A)",
    "ariaLabel7": "小移動: 左",
    "title8": "右 (Shift+→ / Shift+D)",
    "ariaLabel8": "小移動: 右"
  },
  "cameraControlPanel": {
    "text": "セルフリターンの切り替えに失敗しました",
    "text2": "カメラ設定の取得に失敗しました",
    "label": "変更",
    "title": "セルフリターン設定の変更",
    "text3": "セルフリターンを",
    "text4": "オフ",
    "text5": "オン",
    "text6": "にしますか？",
    "text7": "カメラが再起動されます",
    "title2": "エラー"
  },
  "homePositionRow": {
    "text": "ホームポジション"
  },
  "homePositionUpdateDialog": {
    "text": "更新中...",
    "title": "ホームポジション更新の確認",
    "text2": "現在のカメラ位置でホームポジションを更新しますか？"
  },
  "opticalZoom": {
    "title": "ズームアウト (Z)",
    "ariaLabel": "ズームアウト",
    "title2": "ズームイン (X)",
    "ariaLabel2": "ズームイン",
    "title3": "1倍ズーム",
    "text": "ルーラーを非表示",
    "text2": "ルーラーを表示",
    "ariaLabel3": "ルーラー"
  },
  "panelHeader": {
    "text": "PTZ コントロール",
    "ariaLabel": "PTZ パネルを閉じる"
  },
  "presetDeleteDialog": {
    "text": "削除中...",
    "title": "プリセット削除の確認",
    "text2": "」を削除しますか？"
  },
  "presetRow": {
    "ariaLabel": "{{value}}プリセット {{name}} に移動",
    "ariaLabel2": "プリセット {{name}} を削除",
    "text": "選択中 "
  },
  "presetSection": {
    "text": "プリセット",
    "text2": "+ プリセットを追加",
    "text3": "プリセットの取得に失敗しました"
  },
  "ptzPresetModal": {
    "handleError": "プリセットの作成に失敗しました。",
    "title": "プリセットを登録",
    "text": "現在のカメラ位置がプリセットに記録されます",
    "helperText": "{{length}}/{{MAX_TITLE_LENGTH}}文字",
    "label": "タイトル",
    "text2": "プリセット数上限に達しました"
  },
  "relativeDirectionPad": {
    "title": "上 (↑ / W)",
    "ariaLabel": "移動: 上",
    "title2": "下 (↓ / S)",
    "ariaLabel2": "移動: 下",
    "title3": "左 (← / A)",
    "ariaLabel3": "移動: 左",
    "title4": "右 (→ / D)",
    "ariaLabel4": "移動: 右"
  },
  "selfReturnToggle": {
    "text": "セルフリターン",
    "text2": "10分後"
  },
  "directionPadParts": {
    "title": "ホームポジション (C)",
    "ariaLabel": "ホームポジション"
  },
  "cameraSidebar": {
    "ariaLabel": "カメラタブ",
    "label": "カメラ",
    "ariaLabel2": "検知結果タブ",
    "label2": "検知結果",
    "text": "360°カメラ"
  },
  "canvasSeekbar": {
    "renderPinSummaryRow": "検知対象:",
    "renderPinSummaryRow2": "検知条件:",
    "renderPinSummaryRow3": "対象カメラ:",
    "renderPinSummaryRow4": "期間:",
    "alt": "AI検知結果",
    "ariaLabel": "表示範囲を狭める",
    "ariaLabel2": "表示範囲を広げる"
  },
  "clipCapacityErrorModal": {
    "label": "クリップ一覧へ",
    "title": "クリップ容量エラー",
    "text": "クリップの保存容量が上限に達しています。",
    "text2": "不要なクリップを削除するか、管理者にお問い合わせください。"
  },
  "clipCreateModal": {
    "label": "10分",
    "label2": "30分",
    "label3": "60分",
    "label4": "2時間",
    "label5": "3時間",
    "label6": "1時間",
    "label7": "6時間",
    "label8": "12時間",
    "label9": "24時間",
    "text": "0秒",
    "push": "{{h}}時間",
    "push2": "{{m}}分",
    "push3": "{{s}}秒",
    "text2": "{{sec}}秒",
    "text3": "{{m}}分{{s}}秒",
    "text4": "作成中...",
    "text5": "作成中のクリップあり",
    "text6": "クリップを作成",
    "title": "クリップの作成",
    "alert": "クリップを作成しています。完了までこのままお待ちください。",
    "alert2": "現在このカメラでは別のクリップを作成中です。完了までお待ちください。",
    "label10": "ムービー",
    "label11": "タイムラプス",
    "text7": "クイック選択",
    "text8": "開始時刻",
    "text9": "終了時刻",
    "text11": "最大3時間までのクリップを作成できます",
    "text12": "動画の長さは10秒以上必要です",
    "text13": "直近の録画期間を自動でセットします。時刻は下の開始・終了から直接変更できます。",
    "text14": "録画期間:",
    "ariaLabel": "録画期間の長さ",
    "text15": "動画の長さ",
    "ariaLabel2": "動画の長さの数値入力",
    "button": "秒",
    "button2": "分",
    "text16": "の録画で作れる動画は最大",
    "text17": "動画の長さは最大",
    "text18": "秒（",
    "text19": "分）です",
    "text20": "指定の録画期間から作れるタイムラプス動画は最大",
    "text21": "です",
    "text22": "録画期間を延ばすか、動画の長さを短くしてください",
    "text23": "クリップを作成できます",
    "text24": "から",
    "text25": "の動画を生成します",
    "text26": "動画の長さは1秒以上で入力してください",
    "text27": "指定期間に録画がありません",
    "minDateTooltip": "タイムラプス録画期間はクラウド録画オプションで延長できます"
  },
  "footerMenu": {
    "text": "レイアウト変更",
    "text2": "再生モード変更",
    "text3": "AI検知アラート",
    "text4": "このブラウザでは",
    "text5": "オン",
    "text6": "オフ",
    "text7": "閲覧ユーザー追加",
    "text8": "管理画面へ戻る"
  },
  "layoutSelectModal": {
    "label": "すべてクリア",
    "label2": "決定",
    "title": "レイアウトを変更する",
    "text": "分割方向",
    "label3": "縦",
    "label4": "横",
    "text2": "分割数",
    "text3": "カメラ選択",
    "text4": "選択中のエリア: {{lockedAreaName}}",
    "text5": "選択中のエリア: {{uniqueAreaCount}}/{{MAX_UNIQUE_AREAS}}",
    "text6": "マルチビューで同時に選択できるのは同一エリアのカメラのみです。異なるエリアのカメラを減らしてください。",
    "text7": "分割",
    "label5": "エリア",
    "placeholder": "エリアを選択",
    "label6": "カメラ",
    "placeholder2": "カメラを選択"
  },
  "liveButton": {
    "text": "再生モード"
  },
  "mobileCameraList": {
    "text": "360°カメラ"
  },
  "mobileFullscreenView": {
    "ariaLabel": "フルスクリーン解除"
  },
  "multiViewCell": {
    "ariaLabel": "セル{{value}}（空）",
    "ariaLabel2": "カメラを追加",
    "ariaLabel3": "セル{{value}}（接続中）",
    "ariaLabel4": "セル{{value}}（エラー）",
    "text": "接続エラー",
    "text2": "接続に失敗しました",
    "ariaLabel5": "再試行",
    "ariaLabel6": "セル{{value}}（{{cameraName}}）",
    "ariaLabel7": "拡大",
    "ariaLabel8": "ズーム倍率",
    "ariaLabel9": "縮小",
    "ariaLabel10": "アクションメニュー",
    "text3": "1画面で表示",
    "text4": "PTZ操作を終了",
    "text5": "PTZ操作"
  },
  "multiViewCellContainer": {
    "text": "この時刻の録画はありません",
    "text2": "録画の読み込みに失敗しました",
    "ariaLabel": "Live に戻る",
    "livePlaybackError": "Live 映像を再生できませんでした。再試行してください",
    "retryLivePlayback": "Live 再生を再試行",
    "cellLabel": "{{cameraName}}の映像セル",
    "selectCell": "{{cameraName}}のセルを選択"
  },
  "playbackControls": {
    "title": "前のフレーム",
    "title2": "10秒戻る",
    "text": "一時停止",
    "text2": "再生",
    "title3": "10秒進む",
    "title4": "次のフレーム"
  },
  "ptzOverlay": {
    "label": "左上へ移動",
    "label2": "上へ移動",
    "label3": "右上へ移動",
    "label4": "左下へ移動",
    "label5": "下へ移動",
    "label6": "右下へ移動",
    "text": "カメラの移動に失敗しました",
    "edgeTimeout": "カメラから応答がありません。カメラの電源と通信状態を確認してください"
  },
  "recordingSourceToggle": {
    "trigger": "クラウド録画",
    "menu": "クラウド",
    "trigger2": "ローカル録画",
    "menu2": "ローカル",
    "ariaLabel": "録画再生のソース"
  },
  "streamModeSelectModal": {
    "label": "決定",
    "title": "再生モードを選ぶ",
    "text": "このブラウザで開いているすべてのライブ映像に適用されます",
    "text2": "低遅延",
    "text3": "安定",
    "ariaLabel": "再生モード"
  },
  "streamingErrorModal": {
    "title": "映像配信サーバーへの接続に失敗しました",
    "description": "しばらく経ってから再度アクセスいただくか、運営までお問い合わせください。",
    "title2": "映像配信の準備に失敗しました",
    "title3": "映像配信セッションの確立に失敗しました",
    "title4": "映像配信との接続が切断されました",
    "description2": "ネットワーク接続を確認してください。問題が解決しない場合は、再接続をお試しください。",
    "title5": "映像ストリームが見つかりません",
    "description3": "カメラが正しく設定されているか確認してください。",
    "title6": "ネットワークエラーが発生しました",
    "description4": "インターネット接続を確認して、再度お試しください。",
    "text": "再試行回数:",
    "text2": "回",
    "button": "再接続",
    "button2": "カメラ一覧に戻る"
  },
  "videoPlayer": {
    "text": "クラウド録画に欠損があります",
    "text2": "ローカル録画で再生できる場合があります",
    "text3": "この時刻の録画はありません",
    "ariaLabel": "Live に戻る",
    "ariaLabel2": "ローカル録画に切替",
    "text4": "録画を読み込み中..."
  },
  "viewerAiDetectionAlert": {
    "text": "20件以上の新しい検知結果があります",
    "text2": "{{count}}件の新しい検知結果があります",
    "text3": "新しい検知結果があります",
    "ariaLabel": "AI検知アラートを閉じる",
    "alt": "{{detectionName}}の検知画像",
    "button": "確認する",
    "text4": "5秒後に自動的に閉じます"
  },
  "viewerFooter": {
    "text": "AI検知",
    "enqueueSnackbar": "音声通話の開始に失敗しました",
    "text2": "クリップ作成を閉じる",
    "text3": "クリップを作成",
    "text4": "ズームを閉じる",
    "text5": "ズーム",
    "text6": "フルスクリーン解除",
    "text7": "フルスクリーン",
    "text8": "AI検知を閉じる",
    "text9": "メニューを閉じる",
    "text10": "メニュー",
    "text11": "マイクをオンにする",
    "text12": "マイクをオフにする",
    "text13": "通話を終了",
    "text14": "通話を開始",
    "text15": "PTZを無効",
    "text16": "PTZを有効",
    "ariaLabel": "PTZ操作",
    "text17": "シークバーを閉じる",
    "text18": "録画を見る",
    "title": "スナップショットを撮影",
    "ariaLabel2": "画面回転",
    "text19": "音声通話を開始しました",
    "text20": "マップを閉じる",
    "text21": "マップを開く"
  },
  "viewerHeader": {
    "button": "マルチビュー終了",
    "ariaLabel": "カメラリストを開く"
  },
  "viewerInviteDialog": {
    "cameraInfoError": "カメラ情報を取得できません。ページを再読み込みしてください。",
    "enqueueSnackbar": "閲覧者権限の取得に失敗しました",
    "enqueueSnackbar2": "招待メールを送信しました",
    "text": "招待メールの送信に失敗しました",
    "text2": "送信中...",
    "text3": "送信",
    "title": "閲覧権限の付与",
    "placeholder": "メールアドレス"
  },
  "zoomBar": {
    "title": "ズームイン",
    "title2": "ズームアウト"
  },
  "errorBoundary": {
    "text": "エラーが発生しました",
    "text2": "予期しないエラーが発生しました",
    "button": "再試行",
    "button2": "ページを再読み込み"
  },
  "types": {
    "janusInitFailed": "ストリーミングサーバーの初期化に失敗しました",
    "janusAttachFailed": "ストリーミングプラグインの接続に失敗しました",
    "janusSessionFailed": "ストリーミングセッションの作成に失敗しました",
    "connectionLost": "接続が切断されました",
    "streamNotFound": "ストリームが見つかりません",
    "networkError": "ネットワークエラーが発生しました",
    "roomJoinFailed": "音声ルームへの参加に失敗しました",
    "roomCreateFailed": "音声ルームの作成に失敗しました",
    "permissionDenied": "マイクのアクセス許可が拒否されました",
    "microphoneError": "マイクの初期化に失敗しました",
    "audioConnectionLost": "音声接続が切断されました",
    "commandFailed": "カメラ操作に失敗しました",
    "presetLoadFailed": "プリセットの読み込みに失敗しました",
    "presetSaveFailed": "プリセットの保存に失敗しました",
    "homePositionFailed": "ホームポジションの操作に失敗しました",
    "cameraNotFound": "カメラが見つかりません",
    "cameraOffline": "カメラがオフラインです",
    "cameraAccessDenied": "カメラへのアクセスが拒否されました",
    "text": "不明なエラーが発生しました"
  },
  "useJanusConnection": {
    "message": "映像配信との接続が復帰できませんでした"
  },
  "useMultiStreaming": {
    "setError": "再接続に{{MAX_RETRY_COUNT}}回失敗しました"
  },
  "useMultiViewRecordingSession": {
    "onError": "録画の読み込みに失敗しました"
  },
  "useMultiViewStreaming": {
    "error": "接続に失敗しました"
  },
  "usePtzCommands": {
    "text": "プリセットの取得に失敗しました",
    "getErrorMessage": "カメラの移動に失敗しました",
    "getErrorMessage2": "ズーム操作に失敗しました",
    "getErrorMessage3": "ズームリセットに失敗しました",
    "getErrorMessage4": "プリセットの移動に失敗しました",
    "getErrorMessage5": "プリセットの削除に失敗しました",
    "getErrorMessage6": "ホームポジションの設定に失敗しました",
    "getErrorMessage7": "ホームポジションへの移動に失敗しました",
    "edgeTimeout": "カメラから応答がありません。カメラの電源と通信状態を確認してください"
  },
  "useRecordingSession": {
    "onError": "録画情報の取得に失敗しました",
    "onError2": "録画の読み込みに失敗しました"
  },
  "useViewerViewState": {
    "text": "カメラ"
  },
  "desktopViewerLayout": {
    "aiAlertDetectionName": "{{cameraName}} / {{detectionName}}",
    "unknownCamera": "不明なカメラ",
    "clipAlreadyProcessingMessage": "現在このカメラでは別のクリップを作成中です。完了までお待ちください。",
    "setClipCreateError": "必要な情報が不足しています",
    "setClipCreateError2": "カメラ情報の取得に失敗しました",
    "setClipCreateError3": "動画長の指定が不正です",
    "message": "クリップの作成を開始しました",
    "message2": "フレームの取得に失敗しました",
    "text": "カメラ",
    "message3": "スナップショットを保存しました",
    "message4": "スナップショットの保存に失敗しました",
    "text2": "マルチビュー ({{splitNumber}}分割)",
    "text3": "AI検知",
    "text4": "AI設定がありません",
    "text5": "AI機能は無効です",
    "text6": "検知条件に一致しました",
    "message5": "テナント情報を取得できないため検知設定を編集できません",
    "message6": "検知詳細を取得できなかったため編集できません。時間をおいて再度お試しください",
    "message7": "テナント情報を取得できないため検知設定を作成できません",
    "message8": "{{detectionName}}{{value}}",
    "message9": "停止対象の検知設定を取得できませんでした",
    "message10": "{{detectionName}}を停止しました",
    "message11": "{{detectionName}}の停止に失敗しました",
    "button": "キャプチャ一覧へ",
    "text7": "クリップの作成に失敗しました",
    "text8": "を更新しました",
    "text9": "を開始しました"
  },
  "errorView": {
    "text": "カメラが見つからない、または閲覧権限がありません。招待元のユーザーに閲覧権限の付与状況を確認してください。",
    "text2": "カメラ情報の取得に失敗しました",
    "text3": "エラーが発生しました",
    "button": "再試行"
  },
  "loadingView": {
    "text": "カメラ情報を取得中..."
  },
  "janusStreamAdapter": {
    "handleError": "セッション初期化に失敗: {{value}}",
    "handleError2": "映像配信との接続が切断されました",
    "handleError3": "プラグインアタッチに失敗: {{value}}",
    "handleError4": "WebRTC応答作成に失敗: {{value}}",
    "handleError5": "トラック処理エラー: {{value}}"
  },
  "playoutDelay": {
    "realtime": "低遅延",
    "stable": "バランス",
    "highStable": "安定",
    "superStable": "より安定",
    "realtime2": "通信が安定している環境向け。追加の遅延なし。",
    "stable2": "軽いカクつきが気になる場合向け。従来より0.5秒ほど遅延増。",
    "highStable2": "通信が不安定な環境向け。従来より1秒ほど遅延増。",
    "superStable2": "映像をできるだけ止めたくない場合向け。従来より1.5秒ほど遅延増。"
  },
  "useStreamAdapter": {
    "message": "再接続に{{MAX_RETRY_COUNT}}回失敗しました"
  },
  "cameraAccess": {
    "viewerCameraForbiddenMessage": "カメラの閲覧権限がありません"
  },
  "ptzLogic": {
    "message": "プリセット名を入力してください。",
    "message2": "同じ名前のプリセットが既に存在します。",
    "message3": "プリセットは最大{{MAX_PRESETS}}個までです。"
  },
  "liveAudioToggleButton": {
    "unmute": "音声をオンにする",
    "mute": "音声をオフにする",
    "disabledDuringCall": "通話中はカメラの音声を出せません"
  },
  "recordingAudioSourceButton": {
    "label": "鳴らす音を選ぶ",
    "camera": "カメラの音",
    "talk": "通話の録音"
  },
  "useVideoRoomTalk": {
    "forbidden": "このカメラでは通話できません",
    "notStreaming": "カメラが配信していないなどの理由で通話できません",
    "busy": "ほかの人が通話中です",
    "startFailed": "通話を開始できませんでした",
    "disconnected": "通話が切れました",
    "playbackRejected": "音を出せないため通話を終了しました"
  },
  "talkOverlayControls": {
    "region": "通話の操作",
    "talking": "通話中",
    "micOn": "マイクをオンにする",
    "micOff": "マイクをオフにする",
    "end": "通話を終了"
  }
}
